export default __webpack_public_path__ + "static/media/RastalPicture.db8e2462.jpg";